var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"platform-preview-access",attrs:{"role":"status"}},[_c('p',[_vm._v(_vm._s(_vm.error || '正在读取项目预览…'))]),(_vm.error)?_c('el-button',{on:{"click":_vm.load}},[_vm._v("重新加载")]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }